export default [
  {
    title: 'Dashboard',
    route: 'check-in',
    icon: 'HomeIcon',
  },
  {
    title: 'Assignments',
    route: 'projects',
    icon: 'CheckSquareIcon',
  },
  {
    title: 'Driver Bookings',
    route: 'driverprojects',
    icon: 'TruckIcon',
  },
  {
    title: 'Help',
    route: 'help',
    icon: 'HelpCircleIcon',
  },
]

// export default [
//   {
//     title: 'Dashboards',
//     route: 'home',
//     icon: 'HomeIcon',
//   },
//   {
//     title: 'Projects',
//     route: 'second-page',
//     icon: 'FileIcon',
//   },
// ]
